import { useState } from "react";
import { ArrowLeft, Download, Headphones, MessageSquarePlus, MoreVertical, Phone } from "lucide-react";
import { VerifiedBadge } from "./VerifiedBadge";
import { LogoMark } from "./Logo";
import { useBrand } from "../../context/brand";
import { statusLabel } from "../../lib/hours";


export const ChatHeader = ({ typing, cfg, onNewChat, onInstall, installBar, children }) => {
  const [menu, setMenu] = useState(false);
  const brand = useBrand();
  return (
  <header className="lz-header" data-testid="chat-header">
    <div className="lz-header-row">
      <ArrowLeft size={22} className="text-[#E8EFE9]" aria-hidden="true" />
      <div className="lz-avatar">
        {brand.wa
          ? <img src="/media/bia-avatar.jpg" alt="Bia" className="lz-bia-photo" data-testid="chat-bia-photo" />
          : <LogoMark size={34} />}
        {(cfg?.online || cfg?.ai) && <span className="lz-online" data-testid="chat-online-dot" />}
      </div>
      <div className="flex-1 min-w-0">
        <p className="lz-title" data-testid="chat-agent-name">
          {brand.wa ? cfg?.agent_name || "Bia" : cfg?.title || brand.name}<VerifiedBadge size={17} testId="chat-verified-badge" />
        </p>
        {brand.subtitle && <p className="lz-subtitle" data-testid="chat-brand-subtitle">{brand.subtitle}</p>}
        <p className="lz-status truncate" data-testid="chat-agent-status">
          {typing ? <span className="lz-typing-label">digitando…</span>
            : brand.wa ? (cfg?.online || cfg?.ai ? "online" : statusLabel(cfg)) : statusLabel(cfg)}
        </p>
      </div>
      <Phone size={19} className="lz-phone text-[#E8EFE9] opacity-80" aria-hidden="true" />
      <button data-testid="chat-menu-button" className="lz-menu-btn" aria-label="Menu" onClick={() => setMenu((v) => !v)}>
        <MoreVertical size={19} />
      </button>
      {menu && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setMenu(false)} />
          <div className="lz-menu" data-testid="chat-menu">
            {onInstall && (
              <button data-testid="chat-menu-install" onClick={() => { setMenu(false); onInstall(); }}>
                <Download size={16} /> Instalar app de suporte
              </button>
            )}
            <a href={brand.support} data-testid="chat-menu-support"><Headphones size={16} /> Suporte</a>
            <button data-testid="chat-menu-new" onClick={() => { setMenu(false); onNewChat?.(); }}>
              <MessageSquarePlus size={16} /> Nova conversa
            </button>
          </div>
        </>
      )}
    </div>
    {!brand.wa && (
      <div className="lz-ticker" aria-hidden="true">
        <div className="lz-ticker-track">
          {[...brand.ticker, ...brand.ticker].map((t, i) => (
            <span key={i}><i className="lz-dot" />{t}</span>
          ))}
        </div>
      </div>
    )}
    {installBar && (
      <button className="lz-install-bar" data-testid="chat-header-install" onClick={installBar}>
        <Download size={16} className="shrink-0" />
        <span className="flex-1 text-left">Instale o app de suporte e receba avisos das respostas</span>
        <span className="lz-install-bar-cta">Instalar</span>
      </button>
    )}
    {children}
  </header>
  );
};
